var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapOrigin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.673,6.999c-2.615-2.489-6.729-2.489-9.344,0-2.793,2.659-2.644,7.184.083,9.91l.09.09c2.49,2.49,6.508,2.49,8.985.013l.083-.083c2.747-2.747,2.896-7.271.103-9.93ZM12.001,15.23c-1.833,0-3.319-1.486-3.319-3.319s1.486-3.319,3.319-3.319,3.319,1.486,3.319,3.319-1.486,3.319-3.319,3.319Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapOrigin);
export default __webpack_public_path__ + "static/media/map-origin.e1128ec057d618d581efcb37e6c170da.svg";
export { ForwardRef as ReactComponent };